import { render, staticRenderFns } from "./basicinfomation.vue?vue&type=template&id=443d0d79&scoped=true&"
import script from "./basicinfomation.vue?vue&type=script&lang=js&"
export * from "./basicinfomation.vue?vue&type=script&lang=js&"
import style0 from "./basicinfomation.vue?vue&type=style&index=0&id=443d0d79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443d0d79",
  null
  
)

export default component.exports